"use client"

import { LockIcon } from "@/components/icons/pixel-icons"
import { TOWER_SPRITESHEET, TOWER_SPRITE_COUNT, TOWER_SPRITE_INDEX } from "@/components/game-ui/tower-sprite-index"
import { spriteStripStyle } from "@/components/game-ui/sprite-strip"
import { CodexArtPlaceholder } from "../codex-art-placeholder"

interface TowerThumbnailProps {
  towerId: string
  towerName: string
  isSelected: boolean
  isLocked: boolean
  onClick: () => void
}

export const TowerThumbnail = ({
  towerId,
  towerName,
  isSelected,
  isLocked,
  onClick,
}: TowerThumbnailProps) => {
  const spriteIndex = TOWER_SPRITE_INDEX[towerId]
  const hasSprite = spriteIndex !== undefined

  return (
    <button
      onClick={onClick}
      className={`relative aspect-square rounded-lg overflow-hidden transition-all ${
        isSelected
          ? "ring-2 ring-amber-400 ring-offset-2 ring-offset-slate-900 scale-105"
          : "ring-1 ring-amber-600/30 hover:ring-amber-500/50 hover:scale-102"
      } ${isLocked ? "cursor-default" : "cursor-pointer"}`}
      style={{
        backgroundColor: "#2d3748",
      }}
      title={isLocked ? "Not yet discovered" : towerName}
      disabled={isLocked}
    >
      {/* Undiscovered towers withhold the portrait as well as the name; the
          silhouette would otherwise give the entry away */}
      {isLocked ? (
        <CodexArtPlaceholder dimmed />
      ) : hasSprite ? (
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `url(${TOWER_SPRITESHEET})`,
            ...spriteStripStyle(spriteIndex, TOWER_SPRITE_COUNT),
          }}
        />
      ) : (
        // Discovered, but no portrait in the strip yet (shadowblade, shrine)
        <CodexArtPlaceholder name={towerName} />
      )}

      {/* Locked overlay */}
      {isLocked && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/60">
          <LockIcon size={32} className="text-gray-400" />
        </div>
      )}
    </button>
  )
}
